export default __webpack_public_path__ + "static/media/reception.25c48f92.jpg";